<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card style="border-radius: 1.5em;">
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha inicial</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha final</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button class="btnx" type="filled" color="danger"
                               @click="downloadReport()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item"
                                   color="'default'"
                                   v-for="document in documents"
                                   :value="document.id"
                                   :key="document.id"
                                   :id="document.id"
                                   @click="type=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>
<script>
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import DateUtils, {FORMATS} from "@/global/DateUtils";
import toast from "@/global/ToastConfig";
import integrationsReportsEndPoints from "@/endpoints/reports/integrations-reports/IntegrationsReportsEndPoints";
import {reportNames} from "@/global/constants";

export default {
  components: {
    CompanySelector
  },
  data() {
    return {
      companyId: null,
      initialDate: null,
      finalDate: null,
      documents: [
        {name: ".txt", id: "txt"},
        {name: ".xlsx",id:"xlsx"},
      ],
      isLoading: false,
      rangeMax: 31,
      type:"txt"
    }
  },
  mounted() {
  },
  watch: {
    companyId() {
      this.initialDate = null;
      this.finalDate = null;
    }
  },
  methods: {
    /**
     * Método para sumar dias a una fecha parametro
     * @param finalDate
     * @returns {*|string}
     */
    addDateDays(finalDate) {
      const newDate = DateUtils.addDays({
        date: finalDate, amount: 1
      });
      return DateUtils.parseForced({date: newDate, format: FORMATS.DATE_SHORT});
    },
    /**
     *
     */
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
    },
    /**
     * valida los parametros de búsqueda
     */
    validateForm() {
      if (!this.finalDate || !this.initialDate) {
        throw new Error("Debe seleccionar la fecha inicial y/o la fecha final");
      }
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        throw new Error("La fecha final no puede ser inferior a la fecha inicial");
      }
      const rangeSearch = DateUtils.differenceInDays(
          this.initialDate, this.finalDate
      )
      if (rangeSearch > this.rangeMax) {
        throw new Error("El rango de fechas supera el máximo permitido. Máximo de dias " + this.rangeMax);
      }
      if (!this.companyId) {
        throw new Error("Seleccione una compañía");
      }
    },

    /**
     * lista los parametros de búsqueda
     * @returns {{finalDate: string, companyId: null, initialDate: string}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: this.addDateDays(this.finalDate),
        type:this.type
      }
    },
    /**
     * Método de descarga del reporte  fiduciaria bancolombia
     */
    downloadReport() {
      try {
        this.isLoading = true;
        this.validateForm();
        toast.info("Cargando el  archivo, por favor, espere");
        const params = this.prepareParameters();
        const fileName = reportNames.INTEGRATIONS.FIDUCIARY_BANCOLOMBIA.title
            +"_desde_"+DateUtils.toDateShortString({
              date: this.initialDate,
            })+"_hasta_"+DateUtils.toDateShortString({
          date: this.finalDate,
        });
        integrationsReportsEndPoints.downloadFiduciaryBancolombia(params ,fileName)
            .then(response => {
              toast.ok("Archivo descargado exitosamente")
              this.isLoading = false;
            }).catch(error => {
          toast.error("Error al descargar el archivo")
          this.isLoading = false;
        });
      } catch (error) {
        toast.error(error.toString())
        this.isLoading = false;
      }

    }

  }
}
</script>